var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.user.email_verified_at)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('AccountUnverified')],1)]):_c('div',{staticClass:"Profile"},[_c('account-profile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }